// Centralized Mailchimp tag configuration
// This ensures consistent tagging across all parts of the application

export const MAILCHIMP_TAGS = {
  // User lifecycle tags
  NEW_SIGNUP: 'New Signup (Membership Hub)',
  ONBOARDING_COMPLETED: 'Onboarding Completed (Membership Hub)',
  
  // Subscription status tags (used by webhook)
  ACTIVE_SUBSCRIPTION: 'Active Subscription',
  CANCELLED_ACTIVE: 'Cancelled (Active Until End)',
  INACTIVE_SUBSCRIPTION: 'Inactive Subscription',
  
  // Source tracking
  MEMBERSHIP_HUB_SOURCE: 'Membership Hub Stripe Subscription',
  
  // Combined tag sets for common scenarios
  SIGNUP_TAGS: ['New Signup (Membership Hub)'],
  ONBOARDING_TAGS: ['Onboarding Completed (Membership Hub)'],
  ACTIVE_PAID_TAGS: ['Active Subscription', 'Membership Hub Stripe Subscription'],
  CANCELLED_PAID_TAGS: ['Cancelled (Active Until End)', 'Membership Hub Stripe Subscription'],
  INACTIVE_PAID_TAGS: ['Inactive Subscription', 'Membership Hub Stripe Subscription']
};

// Helper function to get tags for different user states
export const getTagsForUserState = (state, additionalTags = []) => {
  const baseTags = MAILCHIMP_TAGS[`${state.toUpperCase()}_TAGS`] || [];
  return [...baseTags, ...additionalTags];
};

// Helper to combine multiple tag sets
export const combineTags = (...tagSets) => {
  const allTags = tagSets.flat();
  return [...new Set(allTags)]; // Remove duplicates
}; 